import { CopyableField } from "./CopyableField"
import React from "react"

type Props = {
  isMobile: boolean;
  isOwnMessage: boolean;
  senderContactInfo: {
    email: string;
    phoneNumber: string;
    messageId: string | null;
  };

};

export const InitialContactInfoMessage = ({ isMobile, senderContactInfo, isOwnMessage }: Props) => {
  return (

    <div>
      <strong>Kupac je ostavio svoje kontakt podatke za brži dogovor</strong>
      <CopyableField
        isMobile={isMobile}
        label="E-mail"
        value={senderContactInfo.email}
        isOwnMessage={isOwnMessage}
        type="email"
      />
      <CopyableField
        isMobile={isMobile}
        label="Telefon"
        value={senderContactInfo.phoneNumber}
        isOwnMessage={isOwnMessage}
        type="phone"
      />
    </div>

  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/InitialContactInfoMessage.tsx